/* eslint-disable import/no-cycle */
import Const from '../const';
import { saveToOrder, editPendingWebOrders } from '../order/order_action';
import { setErrorAction, errorTypes } from '../application/application_action';
import {
  pendingWebOrderSubmitPaymentSourceAPI, createCreditCardProcessingPurchaseApi,
  getCreditCardProcessingPurchaseResponceApi, pendingWebOrderSubmitAPI, getPaymentConfigsAPI,
  deletePaymentSourceAPI
} from '../../utils/api';
import { trackEvent } from '../../utils/analytics/analytics';
import { screenNames } from '../../components/routes/routes_const';
import { updateCurrentScreen } from '../navigation/navigation_actions';
import { emailErrorAction } from '../user/user_action';
import { paramOrNul, withCaptcha } from '../../../common/config/utils';

const paymentProcessing = (value) => ({
  type: Const.payments.paymentProcessing,
  value
});

const purchaseCompleted = () => (dispatch) => {
  dispatch(updateCurrentScreen(screenNames.whatsNext));
};

const paymentLoading = () => ({
  type: Const.payments.loading
});

const paymentsLoaded = () => ({
  type: Const.payments.loaded
});

const setPaymentsParams = (paymentsParams) => ({
  type: Const.payments.setPaymentsParams,
  paymentsParams
});
const setPaymentsData = (paymentsData) => ({
  type: Const.payments.setPaymentsData,
  paymentsData
});

const setPaymentsResponce = (paymentsResponce) => ({
  type: Const.payments.setPaymentsResponce,
  paymentsResponce
});

const clearPaymentsParams = () => ({
  type: Const.payments.clearPaymentsParams
});

const setPaymentsCardData = (paymentsCardData) => ({
  type: Const.payments.setPaymentsCardData,
  paymentsCardData
});

export const editEmailAction = (props) => (dispatch) => {
  dispatch(paymentLoading());
  dispatch(editPendingWebOrders({ props, dispatch }))
    .then(() => { dispatch(paymentsLoaded()); })
    .catch((error) => {
      dispatch(setErrorAction(error));
      dispatch(paymentsLoaded());
    });
};

export const paymentProcessingAction = (value) => (dispatch) =>  {
  dispatch(paymentProcessing(value));
};

export const createCreditCardProcessingPurchase = (params) => (dispatch) => {
  createCreditCardProcessingPurchaseApi(params)
    .then((res) => { dispatch(setPaymentsData(res)); })
    .catch((error) => { dispatch(setErrorAction({ [errorTypes.error]: error })); });
};

export const getCreditCardProcessingPurchaseResponce = (id) => (dispatch, getState) => {
  const { paymentsResponce } = getState().payment;
  if (paymentsResponce?.okMessage || paymentsResponce?.errorMessage) return;
  getCreditCardProcessingPurchaseResponceApi(id)
    .then((res) => {
      dispatch(setPaymentsResponce(res));
      dispatch(getCreditCardProcessingPurchaseResponce(id));
    })
    .catch((error) => { dispatch(setErrorAction({ [errorTypes.error]:  error })); });
};

const paymentSourceErrorType = {
  ccMatch: 'cc_match',
  ccCantAdd: 'cc_cant_add'
};

export const submitPaymentSourceAction = ({ context, paymentSourceId }) => (dispatch) => {
  const params = { context, with3ds: true };
  dispatch(setPaymentsCardData(context));
  pendingWebOrderSubmitPaymentSourceAPI({ paymentSourceId, params })
    .then((res) => {
      dispatch(setPaymentsParams(res));
    })
    .catch((err) => {
      dispatch(paymentProcessingAction(false));
      const {
        errorType, error, errorCode, errorName
      } = err;
      const  { cardData: { ccType, scheme } } = context;
      trackEvent('add credit card failed', {
        ...paramOrNul('cc type', (ccType || scheme).toLowerCase()),
        ...paramOrNul('failed reason error code', errorCode),
        ...paramOrNul('error message', error),
        ...paramOrNul('failed reason description', errorName),
        'failed reason': 'api error'
      });
      if (errorType === paymentSourceErrorType.ccMatch) {
        dispatch(setErrorAction({ [errorTypes.paymentError]: errorType }));
        return;
      }
      dispatch(setErrorAction({ [errorTypes.paymentError]: errorType }));
    });
};

export const pendingWebOrderSubmitAction = () => (dispatch, getState) => {
  const { payments } = getState();
  if (!payments.paymentProcessing) dispatch(paymentProcessingAction(true));
  pendingWebOrderSubmitAPI()
    .then((order) => {
      dispatch(saveToOrder(order));
      dispatch(paymentProcessingAction(false));
      dispatch(purchaseCompleted());
    })
    .catch((error) => {
      dispatch(paymentProcessingAction(false));
      const saveToOrderProps = { reselectAdvisorAction: {  action: pendingWebOrderSubmitAction } };
      saveToOrder(saveToOrderProps);
      dispatch(setErrorAction(error));
    });
};

export const clearPaymentsParamsAction = () => (dispatch) => {
  dispatch(clearPaymentsParams());
};

export const getPaymentConfigsAction = () => (dispatch) => {
  dispatch(paymentLoading());
  withCaptcha('checkout', (token) => getPaymentConfigsAPI(token)
    .then((res) => {
      dispatch(saveToOrder(res));
      dispatch(paymentsLoaded());
    })
    .catch((error) => {
      dispatch(paymentsLoaded());
      if (error.email) {
        dispatch(emailErrorAction(error));
        dispatch(saveToOrder({ needRefreshPaymentConfig: true }));
        return;
      }
      dispatch(setErrorAction(error));
    }));
};

export const deletePaymentSourceAction = (paymentSourceId) => (dispatch) => {
  dispatch(paymentProcessingAction(false));
  deletePaymentSourceAPI(paymentSourceId)
    .catch((error) => { dispatch(setErrorAction(error)); });
};
